import { Moment } from 'moment';
import * as React from 'react';

interface Props {
    date: Moment;
    dayFormat?: string;
    disabled?: boolean;
    selected: Moment[];
    newlySelected: Moment[];
    onToggle: (day: Moment) => void;
}

export default class Day extends React.PureComponent<Props> {
    public static defaultProps = {
        dayFormat: 'D',
        disabled: false
    };

    constructor(props: Props) {
        super(props);
    }

    public render() {
        const { date, selected, newlySelected } = this.props;

        const isSelected = Boolean(selected.find(sel => date.isSame(sel, 'day')));
        const isNewlySelected = Boolean(newlySelected.find(nsel => date.isSame(nsel, 'day')));

        let clsDay = 'rc-Day';
        if (date.weekday() > 4) {
            clsDay = clsDay + ' weekend';
        }
        if (isSelected) {
            clsDay = clsDay + ' selected';
        }
        if (isNewlySelected) {
            clsDay = clsDay + ' newlySelected';
        }
        if (this.props.disabled) {
            clsDay = clsDay + ' disabled';
        }

        return (
            <div className={clsDay} onClick={this.onToggle}>
                {date.format(this.props.dayFormat)}
            </div>
        );
    }

    private onToggle = (e: React.MouseEvent<HTMLElement>) => {
        const isSelected = Boolean(this.props.selected.find(sel => this.props.date.isSame(sel, 'day')));
        if (!this.props.disabled && !isSelected) {
            this.props.onToggle(this.props.date);
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/calendar/Day.tsx